export const styles = ({ typography, palette }) => ({
  tooltip: {
    fontSize: typography.caption.fontSize,
    background: palette.tooltip.dark,
    color: palette.tooltip.contrastText,
  },
});
